import { t } from "i18next";
import { IconButton } from "UIPalette/IconButton/IconButton";
import { Mood, moodFace } from "./moodFactories";
import { trackSaveHealthData } from "core/monitoring/Events";

export const MoodTrackerWellbeingId = "moodTrackerComponent";

export const MoodTrackerCard = ({ setCurrentMoodValue }: { setCurrentMoodValue: (mood: Mood) => void }) => {
  const handleClickMoodTracker = (mood: Mood) => {
    trackSaveHealthData("Mood");
    setCurrentMoodValue(mood as Mood);
  };

  return (
    <div className="h-[100px] flex flex-col justify-between">
      <h2>{t("home.moodTracker.title")}</h2>
      <div className="flex flex-row justify-between mt-3" id={MoodTrackerWellbeingId}>
        {Object.values(Mood).map((mood) => (
          <IconButton
            key={mood}
            ariaLabel={t<string>([`home.moodTracker.myCurrentMood.${mood}`, "home.moodTracker.myCurrentMood.1"])}
            active={true}
            icon={moodFace(mood as Mood)}
            handleClick={() => handleClickMoodTracker(mood)}
            useSetWidth={false}
          />
        ))}
      </div>
    </div>
  );
};
